import HttpService from "../util/HttpService";
import {ContactDetailDto} from "../dto/ContactDetailDto";
import {SignatureDto} from "../dto/SignatureDto";
import ParamEncrypt from "../util/ParamEncrypt";
import {ChangeRequestFilterDto} from "../dto/admin/ChangeRequestFilterDto";
const CONTEXT_PATH = "/cwm/api/v2";
class CustomerChangeRequestAdminService {

    getPendingContactDetailChangeRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-pending-contact-detail-change-request"));
    }

    acceptOrRejectContactDetailChangeRequest = (contactDetailDto: ContactDetailDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/accept-or-reject-contact-detail-change-request"), ParamEncrypt.encryptObject(contactDetailDto));
    }

    getPendingAddressDetailChangeRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-pending-address-change-request"));
    }

    acceptOrRejectAddressDetailChangeRequest = (addressWrapperDto: any, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/accept-or-reject-address-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(addressWrapperDto));
    }

    getPendingComplaints = () => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-pending-complaint-request"));
    }
    getPendingOtherRequests = () => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-pending-other-request"));
    }

    getPendingBankDetailChangeRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-pending-bank-detail-request"));
    }

    acceptOrRejectBankDetailChangeRequest = (bankDetailWrapperDto: any, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/accept-or-reject-bank-detail-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(bankDetailWrapperDto));
    }
    acceptOrRejectSignatureChangeRequest = (signatureChangeRequestDto: SignatureDto, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/accept-or-reject-signature-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(signatureChangeRequestDto));
    }
    addressChangeRequestHistory = (changeRequestFilterDto: ChangeRequestFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/address-change-request-history"), ParamEncrypt.encryptObject(changeRequestFilterDto));
    }
    contactChangeRequestHistory = (changeRequestFilterDto: ChangeRequestFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/contact-change-request-history"), ParamEncrypt.encryptObject(changeRequestFilterDto));
    }

    bankChangeRequestHistory = (changeRequestFilterDto: ChangeRequestFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/bank-details-change-request-history"), ParamEncrypt.encryptObject(changeRequestFilterDto));
    }

    signatureChangeRequestHistory = (changeRequestFilterDto: ChangeRequestFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/admin-change-request-service/get-signature-change-request-history"), ParamEncrypt.encryptObject(changeRequestFilterDto));
    }

    getAddressChangeRequestDetails = (cin: string, groupId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-address-change-request-details/").concat(ParamEncrypt.encryptData(cin)).concat("/").concat(ParamEncrypt.encryptData(String(groupId))));
    }

    getContactChangeRequestDetails = (cin: string, id: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-contact-change-request-details/").concat(ParamEncrypt.encryptData(cin)).concat("/").concat(ParamEncrypt.encryptData(String(id))));
    }
    getBankChangeRequestDetails = (cin: string, groupId: number, id: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-bank-detail-change-request-details/").concat(ParamEncrypt.encryptData(cin)).concat("/").concat(ParamEncrypt.encryptData(String(groupId))).concat("/").concat(ParamEncrypt.encryptData(String(id))));
    }
    getSignatureChangeRequestDetails = (cin: string, id: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/admin-change-request-service/get-signature-change-request-details/").concat(ParamEncrypt.encryptData(cin)).concat("/").concat(ParamEncrypt.encryptData(String(id))));
    }

}

const customerChangeRequestAdminService = new CustomerChangeRequestAdminService();
export default customerChangeRequestAdminService;